export default __webpack_public_path__ + "static/media/list_active.f781274e.svg";